export const scrollToSelector = (selector, offset = -250) => {
    if (selector) {
        const element = document.querySelector(selector);
        if (element) {
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: elementPosition + offset,
                behavior: "smooth"
            });
        }
    }
};